(function($) {

    var isIE = document.body.style.msTouchAction !== undefined;
    var headerSearchBox = $('header .search-box');
    var headerSearchTrigger = headerSearchBox.find('.search-trigger');
    var headerSearchInput = headerSearchBox.find('input');
    var headerSearchButton = headerSearchBox.find('.button');
    var headerSearchOriginalLink = headerSearchButton.data('original-link');
    var mouseDownHappened = false;

    var menuOverlay = $('.menu-overlay');
    var primaryMenu = $('header').data('primary-menu');
    var fullMenu = $('header').find('.menu-wrapper.menu-full');
    var minimalMenu = $('header').find('.menu-wrapper.menu-minimal');

    // Hovers

    menuOverlay.find('#menu-header-menu-1 > li > a').on('mouseenter', function() {
        if (!isIE) {
            if (window.matchMedia && window.matchMedia("(any-pointer:fine)").matches && !window.matchMedia("(max-width: 1110px)").matches) {
                $(this).parent().siblings().find('a').removeClass('active');
                $(this).closest('.menu').find('.sub-menu').removeClass('active');

                if ($(this).parent().hasClass('menu-item-has-children')) {
                    $(this).addClass('active');
                    $(this).parent().find('.sub-menu').addClass('active');
                }
            }
        }
        else {
            $(this).parent().siblings().find('a').removeClass('active');
            $(this).closest('.menu').find('.sub-menu').removeClass('active');

            if ($(this).parent().hasClass('menu-item-has-children')) {
                $(this).addClass('active');
                $(this).parent().find('.sub-menu').addClass('active');
            }
        }
    });

    // Mobile toggling of submenus
    menuOverlay.find('#menu-header-menu-1 > li > a svg').on('click', function (e) {
        e.preventDefault();

        var listElement = $(this).closest('li');

        listElement.siblings().removeClass('mobile-toggled');
        listElement.siblings().find('.sub-menu').removeClass('active');

        listElement.toggleClass('mobile-toggled');
        listElement.find('.sub-menu').toggleClass('active');
    });

    // Toggling

    $('.menu-toggle').on('click', function() {
        $('body').toggleClass('overflow-hidden');
        $(this).find('.burger').toggleClass('active');
        menuOverlay.toggleClass('overlay-hidden');
        minimalMenu.toggleClass('dark');
        minimalMenu.find('.logo-full').toggleClass('logo-hidden');
        menuOverlay.find('.active').removeClass('active');
        menuOverlay.find('.mobile-toggled').removeClass('mobile-toggled');
    });

    menuOverlay.find('a').on('click', function(e) {
        if (e.target.nodeName !== 'svg' && e.target.nodeName !== 'path') {
            $('.menu-toggle').click();
        }
    })

    // Scrolling functionality

    $(window).on('scroll load', function() {
        var scrollTop = $(window).scrollTop();

        if (primaryMenu === 'minimal' && menuOverlay.hasClass('overlay-hidden')) {
            if (scrollTop >= 100) {
                minimalMenu.addClass('menu-hidden');
                fullMenu.removeClass('menu-hidden');
            }
            else {
                minimalMenu.removeClass('menu-hidden');
                fullMenu.addClass('menu-hidden');
            }
        }
        else if (primaryMenu === 'full') {
            if (scrollTop >= 50) {
                fullMenu.addClass('background-filled');
            }
            else {
                fullMenu.removeClass('background-filled');
            }
        }
    });

    // Search field toggling

    headerSearchButton.on('mousedown', function() {
        mouseDownHappened = true;
    });

    headerSearchTrigger.on('click', function() {
        headerSearchBox.addClass('active');
        headerSearchInput.focus();

        headerSearchInput.one('focusout', function(e) {
            if (!mouseDownHappened) {
                headerSearchBox.removeClass('active');
                headerSearchInput.val('');
                headerSearchButton.attr('data-disabled', 'true');
                headerSearchButton.attr('href', headerSearchOriginalLink);
            }
        });

        headerSearchInput.on('change, keyup', function() {
            var inputValue = headerSearchInput[0].value;
            var queryLength = inputValue.length;
            var queryString = headerSearchOriginalLink + '?q=' + inputValue;

            headerSearchButton.attr('href', queryString);

            if (queryLength > 2) {
                headerSearchButton.attr('data-disabled', 'false');
            } else {
                headerSearchButton.attr('data-disabled', 'true');
            }

        });
    });

})( jQuery );